module.exports = __webpack_public_path__ + "img/cloud-off.bb8229da.svg";